import { NightgraphLogo } from '@components/icons/nightgraph-logo';

/**
 * Loading state of the invite accept page. It only draws what the company picker and the create
 * company state share (logo, title, subtitle, a field and a button), since either can follow.
 */
export const OrganizerInvitationSkeleton = () => (
  <output
    data-testid='organizer-invitation-skeleton'
    aria-label='Loading'
    className='mx-auto flex w-full max-w-160 flex-col items-center px-4'>
    <NightgraphLogo className='w-[180px] text-primary' />
    <div className='mt-10 h-7 w-52 rounded-sm bg-tertiary animate-pulse' />
    <div className='mt-3 h-4 w-80 max-w-full rounded-sm bg-tertiary animate-pulse' />
    <div className='mt-8 flex w-full gap-3'>
      <div className='h-11 flex-1 rounded-md bg-tertiary animate-pulse' />
      <div className='h-11 w-28 rounded-md bg-tertiary animate-pulse' />
    </div>
  </output>
);
